/**
 * Base class for all components.
 * Components are pure data containers with no logic.
 */
export abstract class Component {
  /**
   * Unique identifier for this component type.
   * Used internally for component lookups.
   */
  static readonly type: string;

  /**
   * Returns the component type name.
   */
  get type(): string {
    return (this.constructor as typeof Component).type || this.constructor.name;
  }
}
